import { render, staticRenderFns } from "./gs-remove-from-basket.vue?vue&type=template&id=2fa052dd"
import script from "./gs-remove-from-basket.vue?vue&type=script&lang=ts"
export * from "./gs-remove-from-basket.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports